import { useTracker } from 'framework-listing-lib/internal/providers/TrackerProvider';

export default function useApplicationId() {
  'use memo';
  const { applicationId } = useTracker();

  return applicationId;
}
